<template>
  <div class="two-column-view">
    <div class="left-side-column">
      <div class="column-image">
        <img src="../assets/about.png" alt="About">
      </div>
      <DownloadApp />
    </div>
    <div class="article-content">
        <h1>About Goldenlink+</h1>
        <p>GoldenLink+, also known as GOLD, is a marketing platform that combines Live Audio Social Media, NFT benefits, and AI business intelligence matching.</p>
        <p>Our business ecosystem model is as follows:</p>
        <h5>1. Connections</h5>
        <p>A referral code links all your connections, forming your own sales network bound to your reward algorithms. The wider your connections and the stronger your team or network, the more opportunities you have to earn direct and indirect rewards.</p>
        <h5>2. Marketing</h5>
        <p><strong>Room opening</strong>: Create events to expand the audience for products, services, and brands; continue to increase your influence; gain more followers and audiences; and provide more opportunities to expand your target social media traffic.</p>
        <p><strong>Conversion monetization</strong>: Achieve 2WR bidirectional rewards: commission + tokens<br />Create your exclusive community: Continue to expand your influence, empower your goals with the strength of the community, and promote the marketing conversion of your targets.</p>
        <p><strong>GSG Certificate</strong>: In stages, GOLD will issue a total of 20,000 GSG (Gold Striker Gold) memberships. Unlike GSR (Gold Striker Regular), this qualification allows GSG to refer businesses to join the GOLD app through their network development, thereby becoming The Global Exclusive Marketing Agent: GEMA, associated with that business's ID.</p>
        <p><strong>GEMA Certificate</strong>: As long as it is related to the marketing conversion generated on the GOLD platform, it can cover direct or indirect rewards, extending beyond your own connections to a broader range of benefits.</p>
        <p><strong>NFT Token Auction</strong>: In the early stages of GSG and GEMA certificates, due to their limited edition nature, GOLD will issue different styles of NFT Tokens, giving your asset rights the opportunity to appreciate in value. Even through auctions on the Web 3 NFT Token trading platform, original certificate holders have the opportunity to bind NFTs for transfer and sale. Please stay tuned for future information releases that will provide detailed operational methods.</p>
        <p><strong>NFT Protocol</strong>: It is very important to choose the protocol and issuing chain, such as using the Rone protocol to empower the Bitcoin ecosystem.<br />Traffic Mining: Obtain bidirectional rewards (2WR), commission realization (app version), + token staking (web version).</p>
    </div>
  </div>
</template>

<script>
import DownloadApp from "@/components/DownloadApp.vue";

export default {
  components: {
    DownloadApp,
  },
};
</script>

<style scoped></style>
